import React, { useMemo } from 'react';

import { useAppSelector } from '../../../hooks/react-redux';
import { getRiskToleranceRecalculating } from '../client-risk-tolerance/store';
import { RecalculatingModal } from '../shared/RecalculatingModal';
import { AllClientDatasetDefinitions } from './AllClientDatasetDefinitions';
import { ClientDatasetsButtons } from './ClientDatasetsButtons';

export interface ClientDatasetsConfigureProps {
    datasetId: number;
}

export const ClientDatasetsConfigure: React.FC<ClientDatasetsConfigureProps> = ({ datasetId }) => {
    const isRecalculating = useAppSelector(getRiskToleranceRecalculating);

    const clientDatasetButtons = useMemo(() => <ClientDatasetsButtons datasetId={datasetId} />, [datasetId]);

    if (isRecalculating) {
        return (
            <RecalculatingModal buttons={clientDatasetButtons} />
        );
    }

    return (
        <AllClientDatasetDefinitions title='Configure' datasetId={datasetId} />
    );
};
